// Fechas del negocio siempre en hora de Ecuador (America/Guayaquil, UTC-5).
// No usar new Date().toISOString().split('T')[0]: eso da la fecha en UTC y,
// desde las 19:00 de Ecuador, ya devuelve el día siguiente.
const ZONA_ECUADOR = 'America/Guayaquil';

const formatoFecha = new Intl.DateTimeFormat('en-CA', {
    timeZone: ZONA_ECUADOR,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
});

/** Fecha (YYYY-MM-DD) de un instante, en hora de Ecuador. */
export const fechaEcuador = (valor = new Date()) => formatoFecha.format(new Date(valor));

/** Fecha de hoy (YYYY-MM-DD) en hora de Ecuador. */
export const hoyEcuador = () => fechaEcuador(new Date());

/** Primer día del mes actual (YYYY-MM-DD) en hora de Ecuador. */
export const inicioMesEcuador = () => `${hoyEcuador().slice(0, 8)}01`;

/** Fecha (YYYY-MM-DD) de hace N días, en hora de Ecuador. */
export const haceDiasEcuador = (dias) => {
    const [y, m, d] = hoyEcuador().split('-').map(Number);
    const fecha = new Date(Date.UTC(y, m - 1, d - dias));
    return fecha.toISOString().slice(0, 10);
};
